import * as core from '../../../../../../../core'
import * as stakeholderProjectRole from '../stakeholder-project-role'

export const RESOURCE = {
  payload: {
    description: 'Other',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderProjectRole.RESOURCE.payload.partialId,
    }),
    id: 'Other',
    name: 'Other',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
